import React from 'react';
import PropTypes from 'prop-types';
import RadioGroup from './CustomQuestions/RadioGroup';
import CheckboxGroup from './CustomQuestions/CheckboxGroup';
import Input from './CustomQuestions/Input';
import TextArea from './CustomQuestions/TextArea';
import SingleSelectGroup from './CustomQuestions/SingleSelectGroup';
import MultipleSelectGroup from './CustomQuestions/MultipleSelectGroup';
import { CustomTimes } from './CustomTimes';
import Socium from '../constants/Socium';

const TYPE_COMPONENT_MAP = {
  'Radio Button': RadioGroup,
  'Check Box': CheckboxGroup,
  Input: Input,
  Textarea: TextArea,
  'Single Select': SingleSelectGroup,
  'Multiple Select': MultipleSelectGroup
};

const NYI = () => <div>NYI</div>;
const typeToComponent = type => {
  return TYPE_COMPONENT_MAP[type] || NYI;
};

const questionTypeAPIMap = {
  'Radio Button': '',
  'Check Box': `[]`,
  Input: '_',
  Textarea: '_',
  'Single Select': '',
  'Multiple Select': `[]`
};

export default function CustomQuestions({ questions, codeCat, installationTime }) {
  return (
    <div>
      {questions.map(
        ({ id, name, type, answers, onChange, selectedCategory, is_required, tip }) => {
          const Component = typeToComponent(type);
          const inputName =
            type === `Check Box` // redux form will not work with [] suffix
              ? `get_quotes_question_${id}`
              : `get_quotes_question_${id + questionTypeAPIMap[type]}`;
          return id === Socium.QUESTION_TIME_GROUP_ID ? (
            <CustomTimes
              codeCat={codeCat}
              key={`get_quotes_question_${id}_0`}
              name={`get_quotes_question_${id}_0`}
              title={name}
              installationTime={installationTime}
            />
          ) : (
            <Component
              key={`get_quotes_question_${id}`}
              label={name}
              id={id}
              name={inputName}
              isRequired={is_required}
              initialvalue={answers.find(a => a.selected === 'Y')}
              options={answers.map(({ id, name }) => ({
                value: id,
                label: name
              }))}
              onChange={onChange}
              selectedcategory={selectedCategory}
              tip={tip}
            />
          );
        }
      )}
    </div>
  );
}

CustomQuestions.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object),
  codeCat: PropTypes.string,
  installationTime: PropTypes.string
};
